import apiCall from 'apps/investcore/apiCalls/staff-accounts';
import {
  CreatePage,
  DetailPage,
  EditPage,
  ListPage,
} from 'common/ui/admin-CRUD/page';
import { columnsGenerator } from './config';
import ItemDetail from './detail';
import ItemForm from './form';

export const StaffAccountsListPage = () => (
  <ListPage
    title="All Staff Accounts"
    description="AdminCP login accounts (staff, admin, superadmin)."
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    createUrl={`/admin/staff-accounts/create`}
  />
);

export const StaffAccountsDetailPage = () => (
  <DetailPage
    title="Staff Account"
    apiCall={apiCall}
    listUrl={`/admin/staff-accounts`}
    ItemDetail={ItemDetail}
    resourceName="data"
    options={{ editEnabled: true }}
  />
);

export const StaffAccountsEditPage = () => (
  <EditPage
    title="Staff Account"
    apiCall={apiCall}
    listUrl={`/admin/staff-accounts`}
    ItemForm={ItemForm}
    resourceName="data"
  />
);

export const StaffAccountsCreatePage = () => (
  <CreatePage
    title="Staff Account"
    apiCall={apiCall}
    listUrl={`/admin/staff-accounts`}
    ItemForm={ItemForm}
    resourceName="data"
  />
);
